//
//
//
//
//
//
//
//
//
//
//

export default {
	components: {},
	props: {
		property: {
			default: null
		}
	},
	data: function data() {
		return {
			show: 'current'
		};
	},

	methods: {
		showCurrent: function showCurrent() {
			this.show = 'current';
		},
		showPast: function showPast() {
			this.show = 'past';
		},
		showReport: function showReport() {
			this.show = 'report';
		}
	},
	computed: {},
	created: function created() {
		Event.$on('show-current-residents', this.showCurrent);
		Event.$on('show-past-residents', this.showPast);
		Event.$on('show-report-residents', this.showReport);
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('show-current-residents', this.showCurrent);
		Event.$off('show-past-residents', this.showPast);
		Event.$off('show-report-residents', this.showReport);
	},
	mounted: function mounted() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentListDashboard.vue
// module id = 890a
// module chunks = 0 1